export const ROLES = [
    { id: 1, label: 'Administrator' },
    { id: 2, label: 'IARP' },
    { id: 3, label: 'Merchant' },
];
